import { InvalidTokenError, jwtDecode } from 'jwt-decode';

import * as logger from 'common/utils/Logger';

const decodeJWT = <T = Record<string, unknown>>(token: string): T => {
    try {
        return jwtDecode<T>(token);
    } catch (error) {
        logger.error('Error decoding JWT', error);
        throw new InvalidTokenError('Invalid JWT token');
    }
};

export { decodeJWT };
